import gql from "graphql-tag";
import { toast } from "react-toastify";
import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";
import ParcisionCookies from "../../../utils/Cookies";

export default async function confirmPeraCloseOutPortfolioRequest(decodedResult: string, pid: number) {
  try {
    const decodedResultTxn1 = decodedResult;

    const address = ParcisionCookies.get("address");
    const variables = {
      decodedResultTxn1,
      pid,
      address,
    };

    const query = gql`
      query MyQuery($decodedResultTxn1: String!, $pid: Float!, $address: String!) {
        confirmPeraCloseOutPortfolioRequest(decodedResultTxn1: $decodedResultTxn1, pid: $pid, address: $address) {
          message
        }
      }
    `;

    const data = await getQuery(query, variables);
    // @ts-expect-error
    return data.confirmPeraCloseOutPortfolioRequest;
  } catch (error) {
    toast.error("Failed to confirm closing out contract");
    sentryWrappedException(error);
    throw error;
  }
}
